// TblRiderAlert.message on the backend is a 300-character column.
export const RIDER_ALERT_MAX_LENGTH = 300;

export const riderAlertError = ({ message, active }) => {
  const text = String(message ?? "").trim();
  if (text.length > RIDER_ALERT_MAX_LENGTH) return `Keep the message to ${RIDER_ALERT_MAX_LENGTH} characters`;
  if (active && text === "") return "Write the message before turning the alert on";
  return null;
};

export const riderAlertUrl = (baseUrl, franchiseId) =>
  `${baseUrl}/delivery/rider-alert/${franchiseId ? `?franchise_id=${franchiseId}` : ""}`;
